import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    root: 'flex items-center',
    breadcrumb: 'whitespace-nowrap leading-none',
    separator: 'flex items-center justify-center whitespace-nowrap mx-1.5 text-fg-subtle',
  },
  styles: {
    root: {},
    breadcrumb: {},
    separator: {},
  },
}));
